import React, { useContext } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
} from "@material-ui/core";
// eslint-disable-next-line
import AddIcon from "@material-ui/icons/Add";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import Chip from "../../../../components/basics/Chip";

import { PrescricaoContext } from "../contexts/PrescricaoContext";
import usePrescricaoController from "../controllers/PrescricaoController";
import { HeaderAccordion, TableContent } from "../styles/Prescricao";

// busca de dependentes do cliente principal que esta no listagem,
// pode cadastrar um novo cliente dependente do principal, cadastro rápido
// só aparece se utiliza colaborador parametros empresa

const AccordionPrescricaoCadastroDependente = ({ ...props }) => {
  const { handleChangeOpenAcordion } = usePrescricaoController();
  const { expanded } = useContext(PrescricaoContext);

  return (
    <>
      <Grid item xs={12}>
        <Accordion expanded={expanded.registerDependent || false}>
          <AccordionSummary
            expandIcon={
              <ExpandMoreIcon
                onClick={() => handleChangeOpenAcordion("registerDependent")}
              />
            }
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container spacing={1} alignItems="center">
                <Grid
                  item
                  xs
                  onClick={() => handleChangeOpenAcordion("registerDependent")}
                >
                  <Chip label="DEPENDENTE" bgcolor={"default"} />
                </Grid>

                {/* terá um cadastro rápido de cliente, com vinculo de dependente */}

                {/* <Grid item flex={1}>
                  <Tooltip title="Adicionar prescrição de dependente">
                    <IconButtonStyled
                      onClick={() => handleOpenPrescriptionModal(true)}
                    >
                      <AddIcon />
                    </IconButtonStyled>
                  </Tooltip>
                </Grid> */}
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>

          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TableContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      aaaa
                    </Grid>
                  </Grid>
                </TableContent>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
};

export default AccordionPrescricaoCadastroDependente;
